<template>
  <div>
    <div v-if="loading" style="padding:20px">
      <div class="ui active centered inline large loader"></div>
    </div>
    <div v-else class="ui grid" style="padding:20px">

      <div class="row">
        <div class="ten wide column">

            <!-- <label>Best Seller Bedge Change filter settings:</label> -->
            <div class="field" style="padding:5px;padding-top:15px">
              <div class="ui radio checkbox">
                <input type="radio" value="HIGH" v-model="sensitivity">
                <label>No Delay: <small>You get alerts promptly after a change occurs in the Amazon API. <br>
                <span style="color:red;">WARNING:</span> This can result in a lot of notifications! Best Seller Badges can change frequently and repeatedly</small></label>
              </div>
            </div>
            <div class="field" style="padding:5px">
              <div class="ui radio checkbox">
                <input type="radio" value="MEDIUM" v-model="sensitivity">
                <label>Moderate Delay <small> <span style="color:green;">[RECOMMENDED]</span>: We apply a small delay to the Best Seller Badge alerts so we can filter out short-lived changes. </small></label>
              </div>
            </div>
            <div class="field" style="padding:5px">
              <div class="ui radio checkbox">
                <input type="radio" value="LOW" v-model="sensitivity">
                <label>Strong Filtering: <small>We only notify if the Best Seller Badge is lost or gained for a solid amount of time.<br> Use this setting if you are getting too many Best Seller Badge alerts.</small></label>
              </div>
            </div>

        </div>
      </div>
      <div class="row">
        <div class="six wide column">
          <button v-bind:class="dirty ? 'ui primary button' : 'ui disabled primary button'" v-on:click="save()">Save</button>
          <button class="ui basic button" @click="close()">Close </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      loading: true,
      sensitivity: null,
      sensitivityOrig: null,
      dirty: false,
    }
  },
  methods: {
    load: function () {
      this.$http.get('/api/sentinel/watchdogtype/settings/bestSellerBadge').then((response) => {
        this.loading = false
        this.sensitivity = response.body.sensitivity
        this.sensitivityOrig = response.body.sensitivity
      }, (response) => {
        this.loading = false
      })
    },
    close: function () {
      this.$parent.showConfiguration = false
    },
    save: function () {
      this.$http.put('/api/sentinel/watchdogtype/settings/bestSellerBadge', {
        sensitivity: this.sensitivity,
      }).then((response) => {
        this.loading = false
        this.sensitivityOrig = this.sensitivity
        this.dirty = this.sensitivity !== this.sensitivityOrig
      }, (response) => {
        this.loading = false
      })
    },
  },
  created: function () {
    this.load()
  },
  watch: {
    sensitivity: function () {
      this.dirty = this.sensitivity !== this.sensitivityOrig
    },
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// BestSellerBadgeConfig.vue?5de6124c